<script setup lang="ts">
const emit = defineEmits<{
  "update:modelValue": [value: number];
}>();

const props = withDefaults(
  defineProps<{
    modelValue?: number;
    duration?: number;
    buffered?: TimeRanges;
  }>(),
  { modelValue: 0, duration: 1 }
);

const model = useVModel(props, "modelValue", emit, {
  passive: true,
  defaultValue: 0,
});

const { currentPalette } = useTheme();

const progress = computed(() => (model.value / props.duration) * 100);

const buffers = computed(() => {
  if (!props.buffered) return [];

  const buffers = [];

  for (let i = 0; i < props.buffered.length; i++) {
    buffers.push({
      start: (props.buffered.start(i) / props.duration) * 100,
      end: (props.buffered.end(i) / props.duration) * 100,
    });
  }

  return buffers;
});
</script>

<template>
  <div class="video-player-progress relative h-1">
    <div
      class="video-player-progress__wrapper absolute inset-0 bg-white rounded-full overflow-hidden"
    >
      <div class="video-player-progress__buffer absolute inset-0 z-10">
        <div
          v-for="(buffer, index) in buffers"
          :key="index"
          :style="{
            left: `${buffer.start}%`,
            width: `${buffer.end - buffer.start}%`,
          }"
          class="video-player-progress__buffered absolute h-full bg-grey-300 will-change-[left,width]"
        ></div>
      </div>

      <div class="video-player-progress__played absolute inset-0 z-20">
        <div
          :style="{ width: `${progress}%` }"
          class="video-player-progress__played-inner absolute inset-y-0 left-0 h-full will-change-[width]"
          :class="[currentPalette.bg]"
        ></div>
      </div>
    </div>

    <div class="video-player-progress__input absolute inset-0 z-30">
      <input
        type="range"
        :max="props.duration"
        step="1"
        v-model.number="model"
        class="w-full absolute inset-0 h-1 appearance-none cursor-pointer bg-transparent"
        :class="[currentPalette.accent]"
      />
    </div>
  </div>
</template>
